<template>
    <div class="bg-white">
        <template v-if="isPageAllowed">
            <div class="tab-bar relative">
                <el-tabs v-model="activeTabName" @tab-click="changeTabs">
                    <el-tab-pane label="OPPO" name="app_kpi_1" v-if="tabsList.includes('app_kpi_1')"></el-tab-pane>
                    <el-tab-pane label="vivo" name="app_kpi_3" v-if="tabsList.includes('app_kpi_3')"></el-tab-pane>
                    <el-tab-pane label="小米" name="app_kpi_7" v-if="tabsList.includes('app_kpi_7')"></el-tab-pane>
                </el-tabs>
            </div>
            <ListPage :plat-id="platId" :platName="platName" :page-func-names="pageFuncNames"/>
        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面可管理和维护产品的KPI</p>
            </NoPermissionInfo>
        </template>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import HomeAPI from '@/api/home.js';
    import ListPage from './page/listPage';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    export default {
        name: "AppKpiManage",
        components:{
            NoPermissionInfo,
            ListPage,
        },
        data(){
            return {
                isPageAllowed:true,
                dimensionList:[],
                pageFunc:[],
                activeTabName:'',
                activeTab: {
                    name: '',
                },
            }
        },
        computed:{
            ...mapGetters(['tabs_map']),
            platName(){
                if (!this.activeTabName) {
                    return
                };
                const labelData = {
                    'app_kpi_1': 'OPPO',
                    'app_kpi_3': 'vivo',
                    'app_kpi_7': '小米',
                }
                return labelData[this.activeTabName];
            },
            pageFuncNames() {
                return this.pageFunc.map(item => item.name);
            },
            pageDimensionNames(){
                return this.dimensionList.map(item => item.name);
            },
            tabsList() {
                let kpiTabs = this.tabs_map.app_kpi_manage || [];
                return kpiTabs.map(item => item.name);
            },
            platId(){
                return this.activeTabName.split('_').reverse()[0];
            }
        },
        created() {
            this.getPageAllowAction();
            let matchedRoute = this.$route.matched || [];
            this.activeTab = [...matchedRoute].reverse()[0];
            this.activeTabName = this.activeTab.name || 'data_all';
        },
        methods:{
            getPageAllowAction() {
                let navId = this.$route.meta.pid;
                let navTabId = this.$route.meta.id;
                if (navId) {
                    HomeAPI.getPageAllowAction({
                        action_id: navId,
                    }).then(res=>{
                        this.isPageAllowed = true;

                        let resData = res.data || {};
                        let actionData = (resData.page_action || []).find(item => item.id == navTabId);
                        this.dimensionList = this._formatDataConfig(actionData.dimension);
                        this.pageFunc = actionData.func || [];
                    },err=>{
                        console.log('getPageAllowAction error', err);

                        this.isPageAllowed = false;
                        this.dimensionList = [];
                        this.pageFunc = [];
                    })
                }else{
                    this.isPageAllowed = false;
                    this.dimensionList = [];
                    this.pageFunc = [];
                }
            },
            changeTabs(val){
                console.log('changeTabs',val);
                this.$router.push(val.name);
            },
            _formatDataConfig(list) {
                let copyList = JSON.parse(JSON.stringify(list));
                return (copyList || []).map(item => {
                    let configStr = item.config || "{}";
                    item.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.map(child => {
                            let configStr = child.config || "{}";
                            child.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                            return child;
                        })
                    }
                    return item;
                });
            },
        }
    }
</script>

<style scoped>

</style>
